export default "__VITE_ASSET__4GnRKTDk__"